import { SxProps } from '@mui/material/styles'
import { theme } from '@omnea-app/omui/private/theme'

export const getEditableFieldInputStyles = (isEditing?: boolean, hasError?: boolean): SxProps => {
  if (hasError) {
    return {}
  }

  if (isEditing) {
    return {
      '&:hover': {
        cursor: 'text',
      },
    }
  }

  return {
    '& fieldset': { border: 'none' },
    '&:hover fieldset': { borderWidth: '1px', borderColor: theme.palette.neutralLight[300], borderStyle: 'solid' },
  }
}
